import { AuthorizedSenderEmailAddressDTO } from "../DTO/authorizedSenderEmailAddressDTO";

export class AuthorizedSenderEmailAddress{
    public id!: number;
    public customerId!: number;
    public emailAddress!: string;
    public description!: string;
    public enabled!: boolean;
    public unzipZipFiles!: boolean;
    public unzipPassword!: string;
    public added!: Date;
    public edited!: Date;

    public static mapFromDTO(param:AuthorizedSenderEmailAddressDTO):AuthorizedSenderEmailAddress{
        if(!param) throw new Error("parameter is null");
        let obj = new AuthorizedSenderEmailAddress();
        try
        {
            obj.id=param.id;
            obj.customerId=param.customerId;
            obj.emailAddress=param.emailAddress;
            obj.description=param.description;
            obj.enabled=param.enabled;
            obj.unzipZipFiles=param.unzipZipFiles;
            obj.unzipPassword=param.unzipPassword;
            if(param.added) obj.added=new Date(param.added);
            if(param.edited) obj.edited=new Date(param.edited);
        }
        catch(e){
            console.log(e);
        }
        return obj;
    }

    public static mapToDTO(param:AuthorizedSenderEmailAddress):AuthorizedSenderEmailAddressDTO{
        if(!param) throw new Error("parameter is null");
        let dto = new AuthorizedSenderEmailAddressDTO();
        try
        {
            dto.id=param.id;
            dto.customerId=param.customerId;
            dto.emailAddress=param.emailAddress;
            dto.description=param.description;
            dto.enabled=param.enabled;
            dto.unzipZipFiles=param.unzipZipFiles;
            dto.unzipPassword=param.unzipPassword;
            if(param.added) dto.added=param.added.toISOString();
            if(param.edited) dto.edited=param.edited.toISOString();
        }
        catch(e){
            console.log(e);
        }

        return dto;
    }

}